import paginationSelectors from 'modules/shared/pagination/paginationSelectors';
export default paginationSelectors(
  'booking.list',
);
